import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import WorkflowSection from "../sections/WorkflowSection";
import SimpleFromDayOne from "../sections/SimpleFromDayOne";
import FinalCTA from "../sections/FinalCTA";

export default function HowItWorks() {
  return (
    <>
      <SEO
        title="How it works"
        description="From first hello to final invoice — see how ClientDesk VA organizes a virtual assistant business end-to-end."
        path="/how-it-works"
      />
      <section className="pt-20 pb-8 bg-[#FAF7F2]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
              How it works
            </div>
            <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.03em] text-[#1A2A3A] mb-5">
              One clean path from first inquiry to lasting client.
            </h1>
            <p className="text-[17px] text-[#57534E] max-w-2xl mx-auto leading-relaxed">
              Every step lives in one workspace and hands off to the next
              without you rewriting the same details twice.
            </p>
          </Reveal>
        </div>
      </section>
      <WorkflowSection />
      <SimpleFromDayOne />
      <FinalCTA />
    </>
  );
}
